export const APPROVAL_BONUS_ENDPOINTS = {
  GET_APPROVAL_BONUS: 'api/v1/badge/assignments/approval-bonus',
  GET_APPROVAL_REWARDS_COUNTS: 'api/v1/badge/assignments/admin/rewards',


  GET_APPROVAL_REWARDS_COUNTS_EMPLOYEE: 'api/v1/badge/assignments/employee/rewards',
  GET_APPROVAL_BONUS_EMPLOYEE: 'api/v1/badge/assignments/employee/approval-bonus'
}